(function () {
    'use strict';

    angular
        .module('app.gameTracker')
        .config(configRoutes);

    configRoutes.$inject = ['$stateProvider', 'gameTrackerResolver', 'gameTrackerSummaryResolver', 'gameTrackerScoringResolver', 'gameTrackerGirResolver', 'gameTrackerDrivingResolver', 'gameTrackerRecoveryResolver', 'gameTrackerPuttingResolver', 'gameTrackerParResolver'];
    function configRoutes($stateProvider, gameTrackerResolver, gameTrackerSummaryResolver, gameTrackerScoringResolver, gameTrackerGirResolver, gameTrackerDrivingResolver, gameTrackerRecoveryResolver, gameTrackerPuttingResolver, gameTrackerParResolver) {
        $stateProvider.state('scoring.game-tracker', {
            url: '/game-tracker?{courseId:int}&{range:string}',
            component: 'sc3GameTracker',
            resolve: gameTrackerResolver,
            redirectTo: 'scoring.game-tracker.summary',
            params: {
                courseList: null
            }
        });

        $stateProvider.state('scoring.game-tracker.summary', {
            url: '',
            component: 'sc3GameTrackerSummary',
            resolve: gameTrackerSummaryResolver
        });

        $stateProvider.state('scoring.game-tracker.scoring', {
            url: '/scoring',
            component: 'sc3GameTrackerScoring',
            resolve: gameTrackerScoringResolver
        });

        $stateProvider.state('scoring.game-tracker.gir', {
            url: '/gir',
            component: 'sc3GameTrackerGir',
            resolve: gameTrackerGirResolver
        });

        $stateProvider.state('scoring.game-tracker.driving', {
            url: '/driving',
            component: 'sc3GameTrackerDriving',
            resolve: gameTrackerDrivingResolver
        });

        $stateProvider.state('scoring.game-tracker.recovery', {
            url: '/recovery',
            component: 'sc3GameTrackerRecovery',
            resolve: gameTrackerRecoveryResolver
        });

        $stateProvider.state('scoring.game-tracker.putting', {
            url: '/putting',
            component: 'sc3GameTrackerPutting',
            resolve: gameTrackerPuttingResolver
        });

        $stateProvider.state('scoring.game-tracker.par', {
            url: '/par',
            component: 'sc3GameTrackerPar',
            resolve: gameTrackerParResolver
        });
    }
})();